import React from 'react';
import PropTypes from 'prop-types';
import styles from '../pages/login.module.scss';

// Zajednicki okvir auth ekrana (prijava, novi PIN): slika levo, forma desno.
const AuthSplitLayout = ({ children }) => (
  <div className={styles.login}>
    <aside
      className={styles.login__aside}
      style={{ backgroundImage: 'url(/assets/login-aside.png)' }}
    >
      <div className={styles.login__aside__overlay} />
      <div className={styles.login__aside__content}>
        <span className={styles.login__aside__brand}>Galena Park</span>
      </div>
    </aside>

    <main className={styles.login__panel}>
      <div className={styles.login__box}>
        <div className={styles.login__logo}>
          <img src="/logo.svg" alt="Galena" width={140} height={85} />
        </div>
        {children}
      </div>
    </main>
  </div>
);

AuthSplitLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthSplitLayout;
